// extracted by mini-css-extract-plugin
module.exports = {"labelAndSelect":"ReviewsSort_labelAndSelect__g6aJw","label":"ReviewsSort_label__mIavu","sortButton":"ReviewsSort_sortButton__L8nu6","sticky":"ReviewsSort_sticky__CYUaD"};